<script lang="ts">
  import Arrow from '~icons/mdi/arrow-left-right-bold';
  import Equal from '~icons/mdi/equal';
  import Board, { initializeSelection } from '../../board/Board.svelte';
  import Tile from '../../board/Tile.svelte';
  import Star from '../../icons/Star.svelte';
  import GameContext from '~/store/GameContext.svelte';
  import { Tutorial } from '~/store/daily.svelte';
  import { lettersToBoard } from '~/board/utils';
  import DimensionsContext from '~/utils/DimensionsContext.svelte';

  const board = lettersToBoard([
    ['', '', '', '', ''],
    ['', '', '', '', ''],
    ['', '', '', '', ''],
    ['', '', '', '', ''],
    ['', '', '', '', ''],
  ]);

  const ex1 = new Tutorial(board);
  const ex2 = new Tutorial(board);

  const s1 = initializeSelection();
  const s2 = initializeSelection();

  ex1.highlighted[ex1.board[2][2].id] = 'blue';
  for (const [i, j] of [
    [1, 1],
    [1, 2],
    [1, 3],
    [2, 1],
    [2, 3],
    [3, 1],
    [3, 2],
    [3, 3],
  ]) {
    ex1.highlighted[ex1.board[i][j].id] = 'green';
  }

  ex1.highlighted[ex1.board[2][2].id] = 'blue';
  ex2.highlighted[ex2.board[2][2].id] = 'blue';
  for (const [i, j] of [
    [0, 0],
    [0, 1],
    [0, 2],
    [0, 3],
    [0, 4],
    [1, 0],
    [1, 4],
    [2, 0],
    [2, 4],
    [3, 0],
    [3, 4],
    [4, 0],
    [4, 1],
    [4, 2],
    [4, 3],
    [4, 4],
  ]) {
    ex2.highlighted[ex2.board[i][j].id] = 'green';
  }

  const blankTile = {
    id: '',
    letter: '',
    points: 0,
  };

  const size = {
    width: 240,
    height: 240,
  };
</script>

<div class="grid">
  <h3>Swapping adjacent tiles costs 1 star</h3>
  <div class="star-container">
    <Tile tile={blankTile} highlighted="blue" size="small" />
    <Arrow size="2em" />
    <Tile tile={blankTile} highlighted="green" size="small" />
    <Equal size="2em" />
    <Star color="penalty" />
  </div>
  <div class="board-container">
    <GameContext game={ex1}>
      <DimensionsContext {...size}>
        <Board selected={s1} disabled />
      </DimensionsContext>
    </GameContext>
  </div>
  <h3>All other swaps cost 2 stars</h3>
  <div class="star-container">
    <Tile tile={blankTile} highlighted="blue" size="small" />
    <Arrow size="2em" />
    <Tile tile={blankTile} highlighted="green" size="small" />
    <Equal size="2em" />
    <Star color="penalty" />
    <Star color="penalty" />
  </div>
  <div class="board-container">
    <GameContext game={ex2}>
      <DimensionsContext {...size}>
        <Board selected={s2} disabled />
      </DimensionsContext>
    </GameContext>
  </div>
</div>

<style lang="scss">
  h3 {
    text-align: center;
    font-size: 1rem;
  }

  .grid {
    display: grid;
    gap: 1em;
    justify-content: space-around;
    align-items: center;
  }
  .star-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .board-container {
    :global(*) {
      pointer-events: none;
    }
    & :global(.tile .score) {
      display: none;
    }
  }
</style>
